module.exports = __webpack_public_path__ + "8d9e6c244d82ca4df4f3f146e604b481.pdf";